// "Need backup?" — support-hours row linking to WhatsApp chat, fronted by
// a squad of tactical operator icons.
import { Crosshair, Ghost, Radio, Shield } from 'lucide-react';
import { BUSINESS } from '../../constants/business';

const SQUAD = [
        { Icon: Ghost, label: 'Ghost' },
        { Icon: Crosshair, label: 'Recon' },
        { Icon: Shield, label: 'Tank' },
        { Icon: Radio, label: 'Comms' },
];

export default function NeedBackup() {
        return (
                <a
                        href={BUSINESS.whatsappUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="pdp-need-backup"
                        className="mt-6 flex items-center gap-4 group"
                >
                        <span className="relative flex -space-x-2.5 shrink-0">
                                {SQUAD.map(({ Icon, label }, i) => (
                                        <span
                                                key={label}
                                                title={label}
                                                style={{ zIndex: SQUAD.length - i }}
                                                className="h-9 w-9 rounded-full border-2 border-[#0A0A0A] bg-[#1A1A1A] flex items-center justify-center transition-transform duration-200 group-hover:-translate-y-0.5"
                                        >
                                                <Icon className="h-4 w-4 text-[#FF9F1C]" strokeWidth={1.75} />
                                        </span>
                                ))}
                                <span className="absolute -top-0.5 -right-0.5 h-2.5 w-2.5 rounded-full bg-emerald-400 border-2 border-[#0A0A0A] z-10" />
                        </span>
                        <span>
                                <span className="font-sans text-[14px] text-white underline underline-offset-4 decoration-white/30 group-hover:decoration-[#FF9F1C] group-hover:text-[#FF9F1C] transition-colors">
                                        Need backup?
                                </span>
                                <span className="block mt-0.5 font-sans text-[12px] text-white/55">
                                        Our support squad is on WhatsApp Monday to Saturday: 10am–7pm IST.
                                </span>
                        </span>
                </a>
        );
}
